const ThirdTitle = ({ title, className = '' }) => {
  return (
    <h3
      className={`font-serif text-xl sm:text-2xl font-semibold leading-normal
        text-text-primary
        ${className}`}>
      {title}
    </h3>
  );
};

export default ThirdTitle;
